// extracted by mini-css-extract-plugin
export default {"ingredientsListByType":"ingredient-list_ingredientsListByType__gfPRZ burger-ingredients_ingredientsList__5VmPB","link":"ingredient-list_link__7RaGf"};